import { useState }from "react";
import { AuthFetch, AuthFetchRecharge } from "../services/api";
import { useModal } from "./useModal";
import { notify } from "../utils/utils";

export const useHistorialRecargas = () =>{
    const [isOpenHistorial, openModalHistorial, closeModalHistorial] = useModal();
    const [recargaHistorial , setRecargaHistorial ] = useState([]);


    const listarHistorialRecargas = async (uid) => {
        const response = await AuthFetchRecharge(`/Recharge/userHistory/${uid}`)
        !response.isValid && notify(response.exceptions[0].description , 'error')
        if (response.isValid){
            setRecargaHistorial(response.content)
            openModalHistorial();
        }
    }
    

    return { listarHistorialRecargas, recargaHistorial, isOpenHistorial, closeModalHistorial}; 

}